/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Text, BrandColors, MaterialIcon, Header } from '@blend/enterprise-components';

export const styles = StyleSheet.create({
  closingTitle: {
    width: 112,
  },
  infoItem: {
    marginRight: 8,
  },
  infoRow: {
    alignItems: 'center',
    display: 'flex',
    ':not(:last-child)': {
      marginBottom: 8,
    },
  },
});

export namespace LoanInfoRow {
  export interface Props {
    iconType?: MaterialIcon.Props['type'];
    rowHeader: string;
    rowInfo: string;
  }
}

export const LoanInfoRow: React.FC<LoanInfoRow.Props> = ({ rowHeader, rowInfo, iconType }) => {
  return (
    <div className={css(styles.infoRow)}>
      {iconType && (
        <div className={css(styles.infoItem)}>
          <MaterialIcon color={BrandColors.NIGHT} size={24} type={iconType} />
        </div>
      )}
      <div className={css(styles.closingTitle)}>
        <Header size={5}>{rowHeader}</Header>
      </div>
      <div>
        <Text>{rowInfo}</Text>
      </div>
    </div>
  );
};
